import React from "react";
import { Dialog } from '@mui/material';
import colors from "../../colors";
import { useNavigate } from "react-router-dom";
import QRCode from 'react-qr-code';

const InformativeScaDialog = ({ isDialogOpened, handleClose }) => {
    const navigate = useNavigate()

    const handleCloseDialog = (event, reason) => {
        if (reason !== "backdropClick") {
            handleClose();
            navigate('/login')
        }
    };

    return (
        <Dialog
            open={isDialogOpened}
            onClose={handleCloseDialog}
            disableEscapeKeyDown={true}
            keepMounted
            fullWidth
            maxWidth="lg"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '20px',
                    width: '560px',
                    height: 'auto',
                    padding: '30px',
                    zIndex: 888,
                },
            }}
        >
            <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                <span style={{ fontSize: '24px', fontWeight: 700, color: colors.darkBlue, marginTop: '20px' }}>
                    Ju keni përfunduar regjistrimin me sukses!
                </span>
                <span style={{ fontSize: '16px', fontWeight: 400, color: colors.gray, marginTop: '15px' }}>
                    Për të aksesuar llogarinë nga web, ju duhet të regjistroni celularin tuaj si një pajisje të besuar.
                    Pasi ta keni regjistruar, mund ta perdorni celularin për të gjeneruar kodin një-perdorimësh.
                </span>
                <span style={{ fontSize: '16px', fontWeight: 500, color: colors.darkBlue, marginBottom: '20px', marginTop: '15px' }}>
                    Shkarko EasyPay App në:
                </span>
                <QRCode style={{ height: "auto", maxWidth: "40%" }} value={'https://login.easypay.al/DownloadApp'} />
                <button
                    onClick={handleCloseDialog}
                    style={{
                        width: '260px',
                        height: '40px',
                        marginTop: '20px',
                        fontSize: '15px',
                        fontWeight: 700,
                        border: 'none',
                        borderRadius: '10px',
                        color: colors.darkBlue,
                        background: colors.lightGray,
                        cursor: 'pointer',
                    }}
                >
                    Në rregull
                </button>
            </div>
        </Dialog>
    );
};

export default InformativeScaDialog;
